module.exports = __webpack_public_path__ + "img/tabbar-menu.458c6c8b.png";